<template>
  <div class="bin-filter-form custom-wrapper">
    <div class="filter-wrapper" >
      <el-form
        label-position="right"
        label-width="100px"
        ref="filterForm"
        :model="filterForm">

        <el-form-item
          label="应用名"
          prop="app_id"
          v-if="hasRes('app_info_index')" >
          <el-select
            filterable
            default-first-option
            v-model="filterForm.app_id"
            style="width: 100%;">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="appInfo in appInfoList"
              :key="appInfo.app_id"
              :label="appInfo.app_name"
              :value="appInfo.app_id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="应用 ID" prop="app_id">
          <el-input
            v-model="filterForm.app_id"
            placeholder="请输入应用 ID"
            @keyup.enter.native="onFilterSubmit">
          </el-input>
        </el-form-item>

        <el-form-item label="升级包 ID" prop="bin_id">
          <el-input
            v-model="filterForm.bin_id"
            placeholder="请输入升级包 ID"
            @keyup.enter.native="onFilterSubmit">
          </el-input>
        </el-form-item>

        <el-form-item label="版本号" prop="version">
          <el-input
            v-model="filterForm.version"
            placeholder="请输入升级包版本号"
            @keyup.enter.native="onFilterSubmit">
          </el-input>
        </el-form-item>

        <el-form-item label="升级包类型" prop="type">
          <el-select
            v-model="filterForm.type"
            style="width: 100%;">
            <el-option label="全部" value=""></el-option>
            <el-option label="普通" value="0"></el-option>
            <el-option label="定制版" value="1"></el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <div class="submit">
        <el-button
          type="danger"
          size="medium"
          @click="onFilterSubmit">查询</el-button>
        <el-button
          size="medium"
          @click="resetFilters">重置</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_PAGE, SET_FILTERS } from '@/store/modules/table'

export default {
  name: 'BinFilterForm',
  data () {
    return {
      filterForm: {
        app_id: '',
        bin_id: '',
        version: '',
        type: ''
      }
    }
  },
  computed: {
    ...mapState('app', [
      'appInfoList'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_PAGE,
      SET_FILTERS
    ]),
    ...mapActions('app', [
      'getAppInfos'
    ]),

    async getSelectDatas () {
      if (this.hasRes('app_info_index')) {
        await this.getAppInfos({
          page: 1,
          pageSize: 9999
        }).catch(err => {
          console.log(err)
        })
      }
    },
    onFilterSubmit () {
      this.setPage(1)
      this.setFilters(this.filterForm)

      this.$emit('filter')
    },
    resetFilters () {
      this.$refs['filterForm'].resetFields()

      this.getSelectDatas()
    }
  },
  async mounted () {
    try {
      await this.getSelectDatas()

      if ('app_id' in this.$route.query) {
        this.filterForm.app_id = this.$route.query.app_id
      }
    } catch (err) {
      console.log(err)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base";
</style>



// WEBPACK FOOTER //
// src/components/app/BinFilterForm.vue